// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const FloppyDisk_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm20.56 6.75-3.31-3.31A1.5 1.5 0 0 0 16.19 3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V7.81a1.5 1.5 0 0 0-.44-1.06ZM15.75 19.5h-7.5v-5.25h7.5Zm3.75 0h-2.25v-5.25a1.5 1.5 0 0 0-1.5-1.5h-7.5a1.5 1.5 0 0 0-1.5 1.5v5.25H4.5v-15h11.69l3.31 3.31ZM15 6.75a.75.75 0 0 1-.75.75H9A.75.75 0 0 1 9 6h5.25a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'FloppyDisk_Stroke2_Corner0_Rounded',
})
